import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import {
  APIService,
  Billing,
  SumitPayment,
  SumitPaymentMethod,
  Tokens,
  TokenTopUp,
} from 'src/app/API.service';
import { environment } from 'src/environments/environment';
import { D2TApi } from './d2tApi';

export class UserBillingStatus {
  bills: Billing[] = [];
  topUps: TokenTopUp[] = [];
  topUpLinks: { url: string; text: string }[] = [];
  sumBills: number = 0;
  sumTopUps: number = 0;
  sumitPayments: SumitPayment[] = [];
  loadingFlag = true;
  activeTab: string = '';
  billingLinks: { url: string; text: string }[] = [];
  sumApiLogs: number = 0;
  tokenType: string;
  currentBalance: number = 0;
  sumitPaymentsFlag: boolean = false;
  billingData: any;
  billingDataSub: any;
  amountPerPath: { path: string; amount: number }[] = [];
  sumitPaymentMethods: SumitPaymentMethod[];
  showCurrentBalance: boolean = false;
  subscriptionPrice: any;
  totalPrice: any;

  constructor(
    private api: APIService,
    private http: HttpClient,
    public token: Tokens | null
  ) {
    this.tokenType = this.token?.type ?? '';
    this.billingLinks = environment.billingLinks;
    this.topUpLinks = environment.topUpLinks;
  }

  formatDatetime(datetime: string | null | undefined) {
    return moment(datetime).format('YYYY-MM-DD - HH:mm');
  }

  round(val): number {
    return Math.round(val * 100) / 100;
  }

  async calcUserBillingStatus() {
    if (!this.token || !this.token?.owner) {
      return;
    }
    await this.getBilling();
    await this.getPayments();
    await this.getPaymentMethods();

    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getBillingDataForToken();
    const that = this;

    this.billingDataSub = request$.subscribe(async (billingData) => {
      that.billingData = billingData;
      if (!that.token || !that.token?.owner) {
        return;
      }

      that.sumBills = that.billingData.billing.sum;
      that.showCurrentBalance = that.currentBalance > 0;
      that.sumTopUps = that.billingData.topUp.sum;
      that.amountPerPath = that.billingData.billing.amountPerPath;
      that.currentBalance = parseFloat(that.billingData.billing.balance);
      // calc remaining days for current month
      that.subscriptionPrice = this.round(
        that.billingData.billing.subscription.price
      );
      that.totalPrice = that.subscriptionPrice + that.currentBalance;

      if (that.sumitPayments.length > 0) {
        that.sumitPaymentsFlag = true;
        that.activeTab = 'ngb-panel-0';
      } else if (
        !that.sumitPaymentMethods?.length ||
        this.tokenType == 'topUp'
      ) {
        that.activeTab = 'ngb-panel-1';
      } else {
        that.activeTab = 'ngb-panel-2';
      }
      that.loadingFlag = false;
    });
  }

  private async getBilling() {
    if (!this.token || !this.token?.owner) {
      return;
    }
    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getBillings(this.token?.owner);

    request$.subscribe(async (billList: any) => {
      this.bills = billList.items.map((item) => {
        return {
          ...item,
          createdAt: this.formatDatetime(item?.createdAt),
        } as Billing;
      });
    });
  }

  async getPayments() {
    if (!this.token || !this.token?.owner) {
      return;
    }
    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getSumitPayments(this.token?.owner);


    request$.subscribe(async (sumitPaymentsList: any) => {
      this.sumitPayments = sumitPaymentsList.items.map((item) => {
        return {
          ...item,
          createdAt: this.formatDatetime(item?.createdAt),
        } as SumitPayment;
      });
    });    

  }

  private async getPaymentMethods() {
    if (!this.token || !this.token?.owner) {
      return;
    }
    const d2tApi = new D2TApi(this.http, this.token);
    const request$ = d2tApi.getSumitPaymentMethods(this.token?.owner);


    request$.subscribe(async (sumitPaymentMethodsList: any) => {
      this.sumitPaymentMethods = sumitPaymentMethodsList.items.map((item) => {
        return {
          ...item,
          createdAt: this.formatDatetime(item?.createdAt),
        } as SumitPaymentMethod;
      });
    });

  }
}
